<script lang="ts">
	import { HDDivisionType } from '../types/responses/DivisionInfo.js';
	import type { HDDivisionInfoResponse } from '../types/responses/DivisionInfo.js';
	import HDPlayoffStage from './HDPlayoffStage.svelte';
	import type { Season } from '#lib/schema-extension.js';
	import Placeholder from '#lib/components/Placeholder.svelte';
	import { getDivisionInfo } from '../hockeydata.remote.js';

	let {
		season
	}: {
		season: Season;
	} = $props();

	const divisionDataPromise = $derived.by(() => {
		return getDivisionInfo(season);
	});
</script>

<div class="bg-base-100 flex w-full flex-col justify-between gap-3 p-3 md:flex-row">
	{#await divisionDataPromise}
		<Placeholder text="Playoffs werden geladen" />
	{:then divisionData}
		{@const divisions = divisionData.data.divisions
			.filter((d) => d.divisionType === HDDivisionType.PLAYOFF_STAGE_CALCULATED)
			.map((d) => ({ name: d.divisionName, id: d.id.toString() }))}

		{#if divisions && divisions.length > 0}
			{#each divisions as division}
				<HDPlayoffStage divisionId={division.id} />
			{/each}
		{:else}
			Noch keine Playoff Daten verfügbar
		{/if}
	{:catch error}
		<div class="text-xl text-red-500">Error: {error.message}</div>
	{/await}
</div>
